// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-item[data-v-1f6ca1af] {\n  min-height: 24px;\n}\n.text-clickable[data-v-1f6ca1af] {\n  cursor: pointer;\n}\n.text-clickable[data-v-1f6ca1af]:hover {\n  cursor: pointer;\n  color: black;\n}\n", ""]);
// Exports
module.exports = exports;
